import { render, staticRenderFns } from "./Sinergi.vue?vue&type=template&id=16a18da8"
import script from "./Sinergi.vue?vue&type=script&lang=js"
export * from "./Sinergi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports